import React, { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import ImportPanel from './Components/ImportPanel';
import ImportHistory from './Components/ImportHistory';
import DashboardCards from './Components/DashboardCards';
import RecommendationTable from './Components/RecommendationTable';
import PlanList from './Components/PlanList';
import CumulativeReportChart from './Components/CumulativeReportChart';
import ImportStatusCards from './Components/ImportStatusCards';
import SummaryMailPanel from './Components/SummaryMailPanel';
import LastMailStatusCard from './Components/LastMailStatusCard';

export default function InventoryCountingPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [tab, setTab] = useState(0);

  const refresh = () => setRefreshKey((prev) => prev + 1);

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" fontWeight={700} sx={{ mb: 3 }}>
          Inwentaryzacja krocząca
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={tab}
            onChange={(event, newValue) => setTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Dashboard" />
            <Tab label="Import danych" />
            <Tab label="Rekomendacje" />
            <Tab label="Plany" />
          </Tabs>
        </Box>

        {tab === 0 && (
          <Box>
            <DashboardCards refreshKey={refreshKey} />
            <CumulativeReportChart refreshKey={refreshKey} />
            <LastMailStatusCard refreshKey={refreshKey} />
            <SummaryMailPanel refreshKey={refreshKey} onMailSent={refresh} />
          </Box>
        )}

        {tab === 1 && (
          <Box>
            <ImportStatusCards refreshKey={refreshKey} />
            <ImportPanel onImported={refresh} />
            <ImportHistory refreshKey={refreshKey} />
          </Box>
        )}

        {tab === 2 && (
          <RecommendationTable
            refreshKey={refreshKey}
            onPlanCreated={refresh}
          />
        )}

        {tab === 3 && <PlanList refreshKey={refreshKey} />}
      </Box>
    </Container>
  );
}
